import {
  List,
  useTable,
  EditButton,
  ShowButton,
  DeleteButton,
  CreateButton,
} from '@refinedev/antd'
import { Table, Space, Tag, Image, Input, Form } from 'antd'
import type { CrudFilters } from '@refinedev/core'

export { default as ProductCreatePage } from './create'
export { default as ProductEditPage } from './edit'
export { default as ProductShowPage } from './show'

interface ProductRow {
  id: string
  name: string
  slug: string
  price: number
  currency: string
  images: string[]
  badge: 'BESTSELLER' | 'NEW' | null
  stockStatus: 'IN_STOCK' | 'OUT_OF_STOCK'
  active: boolean
  category: { id: string; name: string } | null
}

const BADGE_LABEL: Record<string, string> = { BESTSELLER: 'Bestseler', NEW: 'Novo' }

export function ProductsListPage() {
  const { tableProps, searchFormProps } = useTable<ProductRow>({
    resource: 'products',
    syncWithLocation: true,
    onSearch: (values) => {
      const { search } = values as { search?: string }
      const filters: CrudFilters = [
        { field: 'search', operator: 'contains', value: search || undefined },
      ]
      return filters
    },
  })

  return (
    <List headerButtons={<CreateButton>Dodaj proizvod</CreateButton>}>
      <Form {...searchFormProps} layout="inline" style={{ marginBottom: 16 }}>
        <Form.Item name="search">
          <Input.Search
            placeholder="Pretraga po nazivu ili slug-u"
            allowClear
            onSearch={() => searchFormProps.form?.submit()}
            style={{ width: 320 }}
          />
        </Form.Item>
      </Form>

      <Table {...tableProps} rowKey="id">
        <Table.Column
          title=""
          dataIndex="images"
          width={64}
          render={(images: string[]) =>
            images?.[0] ? (
              <Image src={images[0]} width={44} height={44} style={{ objectFit: 'cover', borderRadius: 6 }} />
            ) : (
              <div style={{ width: 44, height: 44, background: '#f0f0f0', borderRadius: 6 }} />
            )
          }
        />
        <Table.Column title="Naziv" dataIndex="name" sorter />
        <Table.Column
          title="Kategorija"
          dataIndex={['category', 'name']}
          render={(name?: string) => name || <span style={{ color: '#bbb' }}>—</span>}
        />
        <Table.Column
          title="Cena"
          dataIndex="price"
          sorter
          render={(price: number, record: ProductRow) =>
            `${Number(price).toLocaleString('sr-RS')} ${record.currency}`
          }
        />
        <Table.Column
          title="Oznaka"
          dataIndex="badge"
          render={(badge: string | null) =>
            badge ? <Tag color="magenta">{BADGE_LABEL[badge] ?? badge}</Tag> : null
          }
        />
        <Table.Column
          title="Zalihe"
          dataIndex="stockStatus"
          render={(s: string) =>
            s === 'IN_STOCK' ? <Tag color="green">Na stanju</Tag> : <Tag color="red">Nema</Tag>
          }
        />
        <Table.Column
          title="Aktivan"
          dataIndex="active"
          render={(active: boolean) =>
            active ? <Tag color="green">Da</Tag> : <Tag>Ne</Tag>
          }
        />
        <Table.Column<ProductRow>
          title="Akcije"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <ShowButton hideText size="small" recordItemId={record.id} />
              <EditButton hideText size="small" recordItemId={record.id} />
              <DeleteButton hideText size="small" recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  )
}
